<template>
  <div>
    <a-modal
      title="以个人身份报名的运动员"
      width="1200px"
      :visible="visible"
      :maskClosable="false"
      :confirm-loading="confirmLoading"
      :footer="null"
      @cancel="handleCancel"
    >
      <a-table :columns="columns" :data-source="data" :rowKey='record=>record.id' bordered :pagination="false">
        <span slot="image" slot-scope="text, record">
          <img style="width:64px;height:64px;border-radius:5px;" :src="record.image" />
        </span>
        <span slot="sex" slot-scope="text">
          <a-tag color="purple" v-if="text === 0">未知</a-tag>
          <a-tag color="blue" v-if="text === 1">男</a-tag>
          <a-tag color="pink" v-if="text === 2">女</a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <a-button-group size="small">
            <a-button type="dashed" icon="edit" @click="$refs.editPlayer.show(record)">编辑</a-button>
            <a-popconfirm
              title="确定删除吗?"
              @confirm="() => deletePlayer(record.id)"
            >
              <a-button type="danger" icon="delete">删除</a-button>
            </a-popconfirm>
          </a-button-group>
        </span>
      </a-table>
    </a-modal>
    <EditPlayer ref="editPlayer" @ok="initList"/>
  </div>
</template>
<script>
import matchFun from '@comm/utils/matchFun'
import EditPlayer from './modal/EditPlayer'
export default {
  components: {
    EditPlayer
  },
  data () {
    return {
      visible: false,
      confirmLoading: false,
      matchFun: matchFun,
      valData: {
        agencyId: this.$route.query.agencyId,
        pageNum: 1,
        pageSize: 20,
        query: ''
      },
      queryParam: {},
      columns: [{
        title: '头像',
        dataIndex: 'image',
        align: 'center',
        scopedSlots: { customRender: 'image' }
      }, {
        title: '姓名',
        dataIndex: 'name',
        align: 'center'
      }, {
        title: '性别',
        dataIndex: 'sex',
        align: 'center',
        scopedSlots: { customRender: 'sex' }
      }, {
        title: '民族',
        align: 'center',
        dataIndex: 'nationality'
      }, {
        title: '出生日期',
        dataIndex: 'birthday',
        align: 'center'
      }, {
        title: '证件号',
        dataIndex: 'card',
        align: 'center'
      }, {
        title: '操作',
        align: 'center',
        dataIndex: 'action',
        scopedSlots: { customRender: 'action' }
      }],
      data: []
    }
  },
  methods: {
    handleCancel () {
      this.visible = false
    },
    show () {
      this.initList()
      this.visible = true
    },
    initList () {
      this.$api.high.personalPlayerList({}).then(res => {
        if (res.status === 0) {
          this.data = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    deletePlayer (id) {
      this.$api.match.playerDelete({id: id}).then(res => {
        if (res.status === 0) {
          this.$message.success(`成功`)
          this.initList()
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
<style scoped>
.form /deep/ .ant-select-selection{
  border-left:none;
  border-radius: 0 4px 4px 0;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/center/PersonalPlayerForm.vue